// extracted by mini-css-extract-plugin
export default {"settings_container":"setting_settings_container__nxWjr","vertical":"setting_vertical__4rtI9"};